import router from '@/router';
import { PROCESSES_ROUTE_NAME } from '@/router/router.const.js';
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_LOADING, SET_ID, SET_AVAILABLE_WORKFLOWS } from './mutations';
import { loadProcesses, setProcess } from '@/store/modules/processes/actions';
import { id as selectedProcessId } from './getters';
import { processes as processesApi } from '@/api';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

export const load = buildActionObject('load');
export const updateProcess = buildActionObject('updateProcess');
export const deleteProcess = buildActionObject('deleteProcess');
export const loadAvailableWorkflows = buildActionObject('loadAvailableWorkflows');
export const publish = buildActionObject('publish');
export const deleteNode = buildActionObject('deleteNode');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [load.action]({ commit, dispatch }, { id }) {
		if (id) {
			commit(SET_ID, id);
			commit(SET_LOADING, true);
			try {
				await dispatch(setProcess.fullPath, await processesApi.get(id), { root: true });
			} finally {
				commit(SET_LOADING, false);
			}
		}
	},
	async [loadAvailableWorkflows.action]({ commit, getters }) {
		const resp = await processesApi.getAvailableWorklows(getters[selectedProcessId.getter]);
		commit(SET_AVAILABLE_WORKFLOWS, resp);
		return resp;
	},
	async [publish.action]({ getters }) {
		await processesApi.publish(getters[selectedProcessId.getter]);
	},

	async [updateProcess.action]({ getters, dispatch }, { fields }) {
		if (!fields || !Object.keys(fields).length) {
			throw new Error('Update called with bad args');
		}
		const id = getters[selectedProcessId.getter];
		const process = await processesApi.partialUpdate(id, fields);
		await dispatch(setProcess.fullPath, process, { root: true });
		return process;
	},
	async [deleteProcess.action]({ commit, getters, dispatch }) {
		await processesApi.delete(getters[selectedProcessId.getter]);
		await dispatch(loadProcesses.fullPath, undefined, { root: true });
		router.push({ name: PROCESSES_ROUTE_NAME });
		commit(SET_ID, null);
	},
	async [deleteNode.action]({ getters, dispatch }, id) {
		await processesApi.nodes.delete(id);
		const process = await processesApi.get(getters[selectedProcessId.getter]);
		await dispatch(setProcess.fullPath, process, { root: true });
		await dispatch(loadAvailableWorkflows.action);
	},
};

export default actions;
